import { useCallback } from 'react';
import { Logger } from '@saviynt/common';

import { useRotatePasswordMutation } from '../data-layer/serviceIdentityApi';

const useRotatePassword = (serviceId: number | undefined) => {
  // API hooks
  const [rotatePassword, { isLoading: isRotatingPassword }] =
    useRotatePasswordMutation();

  const handleRotatePassword = useCallback(
    async (policyId: number) => {
      try {
        if (!serviceId) {
          throw new Error('No service ID provided');
        }

        const controller = rotatePassword({
          serviceId,
          policyId,
        });

        const response = await controller.unwrap();

        return response;
      } catch (error) {
        Logger.log('Failed to execute action ', error);

        return 'Failed to execute action';
      }
    },
    [rotatePassword, serviceId]
  );

  return {
    handleRotatePassword,
    isRotatingPassword,
  };
};

// eslint-disable-next-line import/prefer-default-export
export { useRotatePassword };
